export default function toPercentage(dec) {
	if (typeof dec === 'string') return dec.split('.')[1] + '%';
	return Math.trunc(+dec * 100) + '%';
}
